import React from "react";
import "./BelowFooter.css";

const BelowFooter = ({ isAlbanian }) => {

  return (
    <nav className="below-footer">
      <div className="below-footer-logo-space">
        <ul
          className="below-footer-first-ul"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <li>&copy; {new Date().getFullYear()} Vila-L sh.p.k.</li>
          <li>
            {isAlbanian ? "Të drejtat e rezervuara" : "All rights reserved"}
          </li>
          <li>
            {isAlbanian ? "Punoi : " : "Designed by: "}
            <a
              href="https://www.doemostech.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Doemos Tech
            </a>
          </li>

          <br />
          <a
            href={`/terms`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "inline-flex",
            }}
          >
            <li className="terms-links">
              {isAlbanian ? "Politikat e privatësisë" : "Terms and Privacy"}
            </li>
          </a>
        </ul>
      </div>
      <div className="below-footer-buttons">
        <ul
          className="below-footer-first-ul"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <li className="terms-link">
            {isAlbanian ? "Orari i Punës :" : "Working hours:"}
          </li>

          <li>
            {isAlbanian
              ? "e Hënë - e Premte : 8:00 AM – 16:00 PM"
              : "Monday - Friday : 8:00 AM – 16:00 PM"}
          </li>
          <li>
            {isAlbanian
              ? "e Shtunë : 8:00 AM – 12:00 PM"
              : "Saturday : 8:00 AM – 12:00 PM"}
          </li>
          <li>{isAlbanian ? "e Dielë : Mbyllur" : "Sunday : Closed"}</li>
          <br />
        </ul>
        <ul
          className="below-footer-second-ul"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <li className="terms-link">{isAlbanian ? "Zyrat :" : "Offices :"}</li>

          <li>
            {isAlbanian
              ? 'Rruga "Sokrat Miho", Pallati Vila-L, Tiranë'
              : '"Sokrat Miho" Street, Building Vila-L, Tiranë'}
          </li>
          <li>info@vila-l.com</li>
          <li>+355 68 200 0187</li>
          <br />
        </ul>
      </div>
      <div className="below-footer-third-part">
        <div
          className="vila-location-square"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <a
            href="https://www.google.com/maps/dir//Vila-L+Group,+Rruga+Sokrat+Miho,+Pallati+Vila-L,+Tiran%C3%AB+1052/@41.3329,19.7772639,18z/data=!4m8!4m7!1m0!1m5!1m1!1s0x135031d1f4f7aedd:0x6f7d72ce57eea687!2m2!1d19.7777854!2d41.3329307?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/vilallocation.png"
              alt="vila-location"
              className="vila-location"
            />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default BelowFooter;
